import React from 'react'
import { Link } from 'react-router-dom';

function FooterTwo() {
    return (
        <div>
            <>
                {/* footer area start */}
                <div className="rts-footer-area rts-section-gap footer-two footer-bg-two mt--120 mt_md--80 mt_sm--60" id='f-contact'>
                    <div className="container">
                        <div className="row">

                            {/* CTA de destaque */}
                            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="footer-two-single-wized left">
                                    <h3 className="title">
                                        <span>Pronto para</span> <br />
                                        Falar com um Especialista?
                                    </h3>
                                    <p className="disc">
                                        A <strong>GB Partner</strong> conecta empresas, produtores rurais e investidores às melhores
                                        soluções financeiras, consultivas e sustentáveis do mercado global.
                                    </p>

                                    <Link className="rts-btn btn-primary-2 color-h-black" to={'/Contato'}>
                                        Fale Conosco
                                    </Link>
                                </div>
                            </div>

                            {/* Soluções Atualizadas */}
                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 mt_sm--50">
                                <div className="footer-two-single-wized two">
                                    <div className="wized-title-area">
                                        <h5 className="wized-title">Nossas Soluções</h5>
                                        {/* Ajustado: /assets/... */}
                                        <img src="/assets/images/footer/under-title-2.png" alt="GB Partner" />
                                    </div>

                                    <div className="wized-2-body">
                                        <ul>
                                            <li>
                                                <Link to={'/servicos/credito-empresarial'}>
                                                    <i className="fal fa-chevron-double-right" /> Crédito Empresarial
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to={'/servicos/agro'}>
                                                    <i className="fal fa-chevron-double-right" /> Agro
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to={'/servicos/seguros'}>
                                                    <i className="fal fa-chevron-double-right" /> Seguros & Proteção
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to={'/servicos/credito-carbono'}>
                                                    <i className="fal fa-chevron-double-right" /> Crédito de Carbono
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to={'/servicos/inteligencia-mercado'}>
                                                    <i className="fal fa-chevron-double-right" /> Inteligência de Mercado
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Contato */}
                            <div className="col-xl-2 col-lg-6 col-md-6 col-sm-12 col-12 mt_sm--30 mt_md--30">
                                <div className="footer-two-single-wized">
                                    <div className="wized-title-area">
                                        <h5 className="wized-title">Contato</h5>
                                        <img src="/assets/images/footer/under-title-2.png" alt="GB Partner" />
                                    </div>

                                    <div className="wized-2-body">
                                        <div className="contact-info-1">
                                            <div className="icon"><i className="fas fa-phone-alt" /></div>
                                            <div className="disc">
                                                <span>WhatsApp</span>
                                                <Link to={'https://wa.me/5571991810262'} target="_blank">(71) 99181-0262</Link>
                                            </div>
                                        </div>

                                        <div className="contact-info-1">
                                            <div className="icon"><i className="fas fa-envelope" /></div>
                                            <div className="disc">
                                                <span>E-mail</span>
                                                <Link to={'mailto:contato@gbpartner.com.br'}>contato@gbpartner.com.br</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Localização */}
                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="footer-two-single-wized right">
                                    <div className="wized-title-area">
                                        <h5 className="wized-title">Localização</h5>
                                        <img src="/assets/images/footer/under-title-2.png" alt="GB Partner" />
                                    </div>
                                    <div className="wized-2-body">
                                        <div className="contact-info-1">
                                            <div className="icon"><i className="fas fa-map-marker-alt" /></div>
                                            <div className="disc">
                                                <span>Endereço</span>
                                                <span>Av. Antônio Carlos Magalhães, 1034 - 2º andar - Itaigara, Salvador - BA, 41825-906 </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {/* footer area end */}

                {/* copyright-area start */}
                <div className="rts-copy-right ptb--30">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="copyright-h-2-wrapper">
                                    <p className="disc">
                                        © {new Date().getFullYear()} <strong>GB Partner</strong> – Todos os direitos reservados.
                                    </p>

                                    <div className="right">
                                        <ul>
                                            <li>
                                                <a href="https://doi2versos.com.br" target="_blank" rel="noopener noreferrer">
                                                    Desenvolvido com ❤️ pela <strong>Doi2Versos</strong>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* copyright-area end */}
            </>
        </div>
    )
}

export default FooterTwo;